import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import TireWarningBottomSheet from '@di-shared/features/diag/tire/TireWarningBottomSheet';

function TireWarningBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={300}>
      <TireWarningBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}

export default TireWarningBottomSheetPage;
